import React from "react";
import { createUseStyles } from "react-jss";

const useStyle = createUseStyles((theme) => ({
	displayNone: {
		display: "none",
	},
}));

const ProductLayout = (props) => {
	let { providerForCard, seoData } = props;
	const classes = useStyle();
	let component = props.children;
	if (providerForCard) {
		let countReview = providerForCard.rating?.order_types?.[0]?.review_all || 1;
		let rating = providerForCard.rating?.order_types?.[0]?.rating
			? providerForCard.rating.order_types[0].rating / 10
			: 0;

		component = (
			<div itemType="https://schema.org/Product" itemScope>
				<meta itemProp="name" content={seoData?.h1 || ""} />
				<meta itemProp="description" content={seoData?.description || ""} />
				<link className={classes.displayNone} itemProp="image" href={providerForCard.logo} />
				<div itemProp="brand" itemType="https://schema.org/Brand" itemScope>
					<meta itemProp="name" content={providerForCard.name || ""} />
				</div>
				{/*<div*/}
				{/*    itemProp="offers"*/}
				{/*    itemType="https://schema.org/AggregateOffer"*/}
				{/*    itemScope*/}
				{/*>*/}
				{/*    <meta*/}
				{/*        itemProp="lowPrice"*/}
				{/*        content={providerForCard.info.min_price}*/}
				{/*    />*/}
				{/*    <meta*/}
				{/*        itemProp="highPrice"*/}
				{/*        content={providerForCard.info.max_price}*/}
				{/*    />*/}
				{/*    <meta*/}
				{/*        itemProp="offerCount"*/}
				{/*        content={providerForCard.info.cnt_tariffs}*/}
				{/*    />*/}
				{/*    <meta itemProp="priceCurrency" content="RUB" />*/}
				{/*</div>*/}
				{/* <div itemProp="aggregateRating" itemType="https://schema.org/AggregateRating" itemScope>
					<meta itemProp="reviewCount" content={countReview} />
					<meta itemProp="ratingCount" content={countReview} />
					<meta itemProp="worstRating" content="0" />
					<meta itemProp="bestRating" content="10" />
					<meta itemProp="ratingValue" content={rating} />
				</div> */}
				{props.children}
			</div>
		);
	}

	return <>{component}</>;
};

export default ProductLayout;
